<template>
  <v-container>
    <v-tabs v-model="tabs" align-tabs="center" color="purple darken-3" dark>
      <v-tab :value="1">Anúncios</v-tab>
      <v-tab @click="getaution" :value="2">Leilões</v-tab>
    </v-tabs>

    <v-tabs-window v-model="tabs">
      <v-tabs-window-item :value="1">
        <v-row>
          <v-col v-for="announcement in userAnaucement" :key="announcement.id" cols="12" sm="6" md="4">
            <v-card :to="{ name: anaucedetalpage, params: { id: announcement.uuid } }" class="mx-auto" max-width="400"
              elevation="3" color="white">
              <v-card-title class="headline white--text text-shadow">{{ announcement.name }}</v-card-title>
              <v-img :src="announcement.photoUrl" height="200px" class="elevation-1">
              </v-img>

              <v-card-subtitle class="grey--text text-darken-2">
                {{ announcement.city }}, {{ announcement.province }}
              </v-card-subtitle>

              <v-card-text class="text-h5 font-weight-bold text--primary">
                Mtn {{ announcement.price }}
              </v-card-text>

              <v-card-actions>
                <v-btn color="purple darken-2" dark>Ver detalhes</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-progress-circular v-if="loading" indeterminate color="purple darken-2"
          class="d-flex justify-center mt-5"></v-progress-circular>
      </v-tabs-window-item>

      <v-tabs-window-item :value="2">
        <v-row>
          <v-col v-for="aution in autonsList" :key="aution.id" cols="12" sm="6" md="4">
            <v-card :to="{name:autiondetailpage, params:{id:aution.uuid}}" class="mx-auto" max-width="400" elevation="3" color="white">
              <v-card-title class="headline white--text text-shadow">{{ aution.name }}</v-card-title>
              <v-img :src="aution.photoUrl" height="200px" class="elevation-1">
              </v-img>

              <v-card-text class="text-darken-3">
                <div><strong>Data de término:</strong> {{ aution.endsAt }}</div>
                <div><strong>Preço inicial:</strong> Mtn {{ aution.inicialPrice }}</div>
                <div><strong>Localização:</strong> {{ aution.city }}, {{ aution.province }}</div>
              </v-card-text>

              <v-card-actions>
                <v-btn color="purple darken-2" dark>Participar do leilão</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-progress-circular v-if="loading" indeterminate color="purple darken-2"
          class="d-flex justify-center mt-5"></v-progress-circular>
      </v-tabs-window-item>
    </v-tabs-window>
  </v-container>
</template>

<script lang="ts">
import PagesName from '@/db/pagenames';
import { defineComponent } from 'vue';
import AutionClient from "../db/userautionquery";
import { anoucemente, auction } from "../db/models";
import AnaucemenClient from "../db/getanaucementlist";
const autionClient = new AutionClient();

const anauceclient = new AnaucemenClient();
const pages = new PagesName();

export default defineComponent({
  name: 'Homepage',

  data() {
    return {
      autonsList: [] as auction[],
      anaucedetalpage: pages.useritemanaucement,
      autiondetailpage: pages.autiondetailuser,
      userAnaucement: [] as anoucemente[],
      loading: true,
      tabs: null
    };
  },

  mounted() {
    this.getanaucement();
  },

  methods: {
    async getanaucement() {
      try {
        this.loading = true;
        this.userAnaucement = await anauceclient.getItemsByPage();
      } catch (error) {
        console.error("Erro ao carregar os anúncios:", error);
      } finally {
        this.loading = false;
      }
    },
    async getaution() {
      try {
        this.loading = true;
        this.autonsList = await autionClient.getItemsByPage();
      } catch (error) {
        console.error("Erro ao carregar os leilões:", error);
      } finally {
        this.loading = false;
      }
    }
  }
});
</script>

<style scoped>
.v-card {
  background-color: #f7f7f7;
  /* Fundo cinza-claro */
  border-radius: 8px;
  /* Bordas arredondadas */
  margin-bottom: 20px;
  transition: transform 0.3s;
}

.v-card:hover {
  transform: scale(1.02);
  /* Efeito de zoom ao passar o mouse */
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
}

.text-shadow {
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.7);
  /* Sombra para destacar o título */
}

.v-card-title {
  font-weight: bold;
}

.v-card-subtitle,
.v-card-text {
  color: #424242;
  /* Texto mais escuro para contraste */
}

.v-card-actions {
  justify-content: flex-end;
}

.v-btn {
  border: 2px solid #5e35b1;
  /* Borda roxa escura */
  font-weight: bold;
}

.v-progress-circular {
  margin-top: 20px;
}
</style>
